<template>
  <div class="group-attention">
    <div class="group-attention-c">
      <div class="header">
        <h3>群发提醒</h3>
        <mk-iconfont
          class="close"
          icon-class="guanbi"
          @click.native="cancel"
        ></mk-iconfont>
      </div>
      <div class="content">
        <div class="target-persons">
          <div class="tit">
            目标人群：
          </div>
          <div class="total">
            总共{{ total }}人
          </div>
        </div>
        <div class="select">
          <!-- <div class="select-item">
            <span class="date-txt">{{ date }}</span>
          </div> -->
          <mk-date-picker
            v-model="date"
            class="select-item"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            disabled
          />
          <mk-select
            v-model="taskIndex"
            class="select-item"
            width="140"
            placeholder="任务完成情况"
            clearable
            @change="change"
          >
            <mk-option
              v-for="(item,index) in taskOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </mk-option>
          </mk-select>
          <mk-select
            v-model="signInIndex"
            class="select-item"
            width="158"
            placeholder="签到状态"
            clearable
            @change="change"
          >
            <mk-option
              v-for="(item,index) in signInOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </mk-option>
          </mk-select>
          <mk-select
            v-model="journalIndex"
            class="select-item last"
            width="140"
            placeholder="日志提交情况"
            clearable
            @change="change"
          >
            <mk-option
              v-for="(item,index) in journalOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </mk-option>
          </mk-select>
        </div>
        <div class="select-tips">
          注：如果该用户超过48小时未和公众号产生互动，将无法从公众号中收到消息提醒
        </div>
        <div class="content-c">
          <div class="tit">
            内容：
          </div>
          <mk-input
            v-model="content"
            type="textarea"
            class="textarea"
            placeholder="请输入消息内容"
            maxlength="200"
            height="85"
            show-word-limit
          />
        </div>
        <div class="execute-time">
          <div style="display:flex;">
            <div class="tit">
              执行时间：
            </div>
            <ul class="radio-group">
              <li class="first">
                <input
                  v-model="state"
                  type="radio"
                  value="promptly"
                />
                <span>立即执行</span>
              </li>
              <li>
                <input
                  v-model="state"
                  type="radio"
                  value="timing"
                />
                <span>定时执行</span>
              </li>
            </ul>
          </div>
          <mk-time-picker
            v-if="state==='timing'"
            v-model="excDate"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="执行时间"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
            @change="timeChange"
          />
        </div>
      </div>
      <div class="handle">
        <mk-button-biz
          width="64px"
          @click="cancel"
        >
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="64px"
          @click="confirm"
        >
          确认
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { BIZAPIS } from '../../../api'
export default {
  data () {
    return {
      total: 0,
      content: '',
      state: 'timing',
      date: '',
      excDate: '',
      signInIndex: '',
      signInOptions: [
        {
          label: '未签到',
          value: 0
        },
        {
          label: '已签到',
          value: 1
        },
        {
          label: '连续两天未签到',
          value: 2
        }
      ],
      taskIndex: '',
      taskOptions: [
        {
          label: '未完成',
          value: 0
        },
        {
          label: '已完成',
          value: 1
        }
      ],
      journalIndex: '',
      journalOptions: [
        {
          label: '未提交',
          value: 0
        },
        {
          label: '已提交',
          value: 1
        }
      ],
      pickerOptions: {
        selectableRange: '18:30:00 - 20:30:00'
      }
    }
  },
  created () {
    this.date = dayjs(new Date()).format('YYYY-MM-DD')
    this.getList()
  },
  methods: {
    change () {
      this.getList()
    },
    timeChange () {
      if (this.state === 'timing') {
        let nowTime = new Date(
          dayjs(new Date()).format('YYYY-MM-DD HH:mm')
        ).getTime()
        let sTime = new Date(
          dayjs(new Date()).format('YYYY-MM-DD') + ' ' + this.excDate
        ).getTime()
        if (nowTime > sTime) {
          this.$message({
            type: 'error',
            message: '执行时间不得晚于当下时间'
          })
          this.excDate = ''
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    confirm () {
      // 确认
      if (this.content) {
        if (this.timeChange()) {
          if (this.total === 0) {
            this.$message({
              type: 'error',
              message: '当前查询结果为0人，不可发送提醒',
              showClose: true
            })
          } else {
            this.sendNews()
          }
        }
      } else {
        this.$message({
          type: 'error',
          message: '请输入消息内容',
          showClose: true
        })
      }
    },
    async sendNews () {
      let metas = {
        content: this.content,
        isImmediate: false
      }
      if (this.signInIndex === 0) {
        metas['isSign'] = 1
      } else if (this.signInIndex === 1) {
        metas['isSign'] = 2
      } else if (this.signInIndex === 2) {
        metas['isSign'] = 3
      } else {
        delete metas['isSign']
      }
      if (this.taskIndex === 0) {
        metas['isTaskFinished'] = false
      } else if (this.taskIndex === 1) {
        metas['isTaskFinished'] = true
      } else {
        delete metas['isTaskFinished']
      }
      if (this.journalIndex === 0) {
        metas['isSubmitLog'] = false
      } else if (this.journalIndex === 1) {
        metas['isSubmitLog'] = true
      } else {
        delete metas['isSubmitLog']
      }
      if (this.state === 'timing') {
        if (this.excDate) {
          metas['performTime'] =
            dayjs(new Date()).format('YYYY-MM-DD') + ' ' + this.excDate + ':00'
        } else {
          this.$message({
            type: 'error',
            message: '请选择执行时间',
            showClose: true
          })
          return
        }
      } else {
        delete metas['performTime']
        metas['isImmediate'] = true
      }
      const res = await BIZAPIS.YqfworkstatisticsApi.yqfWorkStatisticsSendMessagePost(
        metas
      )
      if (res.success) {
        this.$message({
          type: 'success',
          message: '群发消息成功',
          showClose: true
        })
        this.$emit('cancel')
      }
    },
    async getList () {
      let metas = {
        page: 1,
        pageSize: 10
      }
      if (this.signInIndex === 0) {
        metas['isSign'] = 1
      } else if (this.signInIndex === 1) {
        metas['isSign'] = 2
      } else if (this.signInIndex === 2) {
        metas['isSign'] = 3
      } else {
        delete metas['isSign']
      }
      if (this.taskIndex === 0) {
        metas['isTaskFinished'] = false
      } else if (this.taskIndex === 1) {
        metas['isTaskFinished'] = true
      } else {
        delete metas['isTaskFinished']
      }
      if (this.journalIndex === 0) {
        metas['isSubmitLog'] = false
      } else if (this.journalIndex === 1) {
        metas['isSubmitLog'] = true
      } else {
        delete metas['isSubmitLog']
      }
      // if (this.date) {
      //   metas['day'] = this.date
      // } else {
      //   delete metas['day']
      // }
      // if (this.title) {
      //   metas['saleID'] = this.title
      // } else {
      //   delete metas['saleId']
      // }
      // const res = await BIZAPIS.YqfworkstatisticsApi.yqfWorkStatisticsGet(metas)
      const res = await BIZAPIS.YqfworkstatisticsApi.yqfWorkStatisticsCountSendMessageGet(
        metas
      )
      if (res.success) {
        this.total = res.data
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.group-attention {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2001;

  /deep/.el-date-editor--time {
    width: 160px;
    height: 32px;

    .el-input__inner {
      width: 160px;
      height: 32px;
    }
  }

  /deep/ .el-input__prefix {
    .el-icon-date {
      line-height: 32px;
    }
  }

  /deep/ .el-input__icon {
    line-height: 32px;
  }

  .group-attention-c {
    width: 658px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;

    .header {
      // width: calc(100% - 40px);
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;
      border-radius: 4px 4px 0 0;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 14px;
      }

      .close {
        cursor: pointer;
        font-size: 14px;
        color: #bfbfbf;
      }
    }

    .content {
      width: calc(100% - 88px);
      margin: 0 auto;
      padding: 24px 0 32px 0;

      input[type='radio'] {
        -webkit-appearance: none;
        vertical-align: middle;
        background: #fff;
        border: #d1d1d1 solid 1px;
        border-radius: 100%;
        width: 16px;
        height: 16px;
        position: relative;
        border-color: #009cff;
        box-sizing: border-box;
        flex-shrink: 0;
        cursor: pointer;
      }

      input[type='radio']:focus {
        outline: none;
      }

      input[type='radio']:checked::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #009cff;
      }

      .target-persons {
        display: flex;

        .tit {
          font-size: 14px;
          font-weight: 500;
        }

        .total {
          font-size: 14px;
          color: #a1a1a1;
        }
      }

      .select {
        display: flex;
        align-items: center;
        margin-top: 20px;

        .select-item {
          margin-right: 10px;

          .date-txt {
            font-size: 14px;
            font-weight: 500;
            color: #a1a1a1;
          }
        }

        .last {
          margin-right: 0;
        }
      }

      .select-tips {
        color: #a1a1a1;
        font-size: 14px;
        line-height: 14px;
        margin-top: 10px;
      }

      .execute-time {
        margin-top: 28px;
        display: flex;
        height: 32px;
        align-items: center;
        justify-content: space-between;

        .tit {
          font-size: 14px;
          font-weight: 500;
        }

        .radio-group {
          display: flex;
          align-items: center;

          li {
            margin-left: 56px;

            span {
              color: #d9d9d9;
              font-size: 14px;
              margin-left: 8px;
            }
          }

          .first {
            margin-left: 30px;
          }
        }
      }
    }

    .handle {
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
    }

    .content-c {
      margin-top: 24px;

      .tit {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
